export var TypeActionDiscountEvent;
(function (TypeActionDiscountEvent) {
    TypeActionDiscountEvent["ActionButtonClick"] = "DiscountEvent > ActionButtonClick";
    TypeActionDiscountEvent["ActionButtonHide"] = "DiscountEvent > ActionButtonHide";
    TypeActionDiscountEvent["SelectEvent"] = "DiscountEvent > SelectEvent";
    TypeActionDiscountEvent["ShowMe"] = "DiscountEvent > ShowMe";
})(TypeActionDiscountEvent || (TypeActionDiscountEvent = {}));
export var actionDiscountEventActionButtonClick = function (eventType) { return ({
    eventType: eventType,
    type: TypeActionDiscountEvent.ActionButtonClick,
}); };
export var actionDiscountEventActionButtonHide = function (eventId) { return ({
    eventId: eventId,
    type: TypeActionDiscountEvent.ActionButtonHide,
}); };
export var actionDiscountEventSelectEvent = function (eventId) { return ({
    eventId: eventId,
    type: TypeActionDiscountEvent.SelectEvent,
}); };
export var actionDiscountEventShowMe = function () { return ({
    type: TypeActionDiscountEvent.ShowMe,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/actionDiscountEvent.ts
// module id = 285
// module chunks = 3